<template>
  <div :class="`grid ${sortBy.value === 'by_month' && 'grid-cols-5'} grid-cols-4 gap-10 mb-4`">
    <v-select class="w-full" v-model="year" :options="yearOptions" label="label" @input="changeSortParam" />
    <v-select class="w-full" v-model="sortBy" :options="sortOptions" label="label" @input="changeSortParam" />
    <v-select v-if="sortBy.value === 'by_month'" class="w-full" v-model="month" :options="monthOptions" label="label"
      @input="changeSortParam" />
    <v-select class="w-full custom-multiple-select" v-model="state" :options="stateOptions" label="label"
      :multiple="true" @input="changeSortParam" />
    <v-select class="w-full custom-multiple-select" v-model="vehicle" :options="vehicles" label="label" :multiple="true"
      @input="changeSortParam" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { STATE_OPTIONS, MONTH_OPTIONS, SORT_OPTIONS } from '../constants/constants';

export default {
  components: {
    vSelect,
  },
  props: {
    active: {
      type: String,
    },
    fetchParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      year: { label: `${new Date().getFullYear()}`, value: `${new Date().getFullYear()}` },
      sortBy: { label: "By month", value: "by_month" },
      month: { label: new Date().toLocaleString('en-US', { month: 'long' }), value: new Date().toLocaleString('en-US', { month: 'long' }) },
      state: [],
      vehicle: [],

      // Options
      sortOptions: SORT_OPTIONS,
      monthOptions: MONTH_OPTIONS,
      stateOptions: STATE_OPTIONS,
      yearOptions: [
        { label: "2020", value: "2020" },
        { label: "2021", value: "2021" },
        { label: "2022", value: "2022" },
        { label: "2023", value: "2023" },
        { label: "2024", value: "2024" },
        { label: "2025", value: "2025" },
      ],
    };
  },
  methods: {
    changeSortParam() {
      if (!this.sortBy) {
        this.sortBy = this.sortOptions[0]
        return
      }

      const stateValue = this.state.map((el) => el.value).join(",");
      const vehicleValue = this.vehicle.map((el) => el.value).join(",");

      let query = {};

      if (stateValue) {
        query.state = stateValue;
      }

      if (vehicleValue) {
        query.vehicle_id = vehicleValue;
      }

      if (this.year) {
        query.year = this.year.value;
      }

      if (this.sortBy && this.sortBy.quarter) {
        query.quarter = this.sortBy.value;
      }

      if (this.sortBy && this.sortBy.value === "by_month" && this.month) {
        query.month = this.month.value;
      }

      if (this.sortBy && this.sortBy.value === "by_year" || this.sortBy.quater) {
        delete query.month;
      }

      this.$emit('update-object', query);

      switch (this.active) {
        case "Untis":
          this.$store.dispatch("reports/fetchUnitsTable", query);
          break;
        case "States":
          this.$store.dispatch("reports/fetchStateTable", query);
          break;
      }
    },
  },
  computed: {
    vehicles() {
      return this.$store.state.reports.vehicles;
    },
  },
  watch: {
    active(newValue, oldValue) {
      this.changeSortParam();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .custom-multiple-select .vs__selected-options {
  padding: 0px 10px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden; // Prevent vertical overflow
  scrollbar-width: thin;
  max-width: 18dvw; // Full width of parent container
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar {
  height: 2px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-thumb {
  background-color: #a0a0a0;
  /* Color of the scrollbar thumb */
  border-radius: 0px;
}

::v-deep .custom-multiple-select .vs__selected-options::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  /* Color of the scrollbar track */
}
</style>
